export default "/assets/images/download-mila-app.9fc0240a07c91cee.webp";